import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    if (this.element.id === "wg-toast-container") return;

    this.element.style.animation = "fade-in-and-out 4s";
    setTimeout(() => { this.element.remove(); }, 4000);
  }

  show({ detail: { message, type = "notice" } }) {
    const toast = document.createElement("div");
    toast.className = `wg-toast wg-toast-${type}`;
    toast.dataset.controller = "toast";
    toast.textContent = message;
    this.element.appendChild(toast);
  }
}
